import uirouter from '@uirouter/angularjs';
import common from 'app/modules/common';

import holdingFees from './components/fees/fees.ts';
import moduleFundsAdd from './states/funds/add';
import moduleFundsExchange from './states/funds/exchange';
import moduleFundsRemove from './states/funds/remove';

export default angular
  .module('app.holding.dashboard.funds', [
    uirouter,
    common,
    moduleFundsAdd,
    moduleFundsExchange,
    moduleFundsRemove,
  ])
  .component('holdingFees', holdingFees)
  .name;

require('./directives/funds-balance/funds-balance');
require('./directives/funds-more-menu/funds-more-menu');
require('./directives/global-method-selector/global-method-selector');
require('./directives/pending-add/pending-add');
require('./directives/pending-remove/pending-remove');
require('./directives/regional-method-selector/regional-method-selector');
require('./directives/statement-funds/statement-funds');
require('./directives/transfer-instructions/transfer-instructions');
require('./filters/format-funds');
require('./filters/format-funds-add-status');
require('./filters/format-funds-remove-status');
require('./services/funds');
require('./states/funds');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/funds/index.js